<template>
  <top-banner :depthTitle="depthTitle" :imgUrl="imgUrl" :firstTitle="firstTitle" :lastTitle="lastTitle" :breadCate="breadCate"></top-banner>
  <about-menu :isCurrent='isCurrent'></about-menu>
  <div class="ListSec">
    <div class="site-container">
        <h3 class="PageTitle">활동</h3>
        <div class="ListFilter Activity">
          <div class="ListFilterKw">
            <ul class="ListFilterKw-inner">
              <!-- v-for를 사용하여 탭 메뉴 동적 생성 및 클릭 이벤트 바인딩 -->
              <li 
                v-for="(item, index) in activityCategories" 
                :key="index" 
                class="ListFilterKw-item" 
                :class="{ 'is-Current': selectedCategory === item }"
              >
                <a href="#" @click.prevent="changeCategory(item)" class="ListFilterKw-link">{{ item }}</a>
              </li>
            </ul>
          </div>
          <list-search @searchData="getSearchData" id="search"></list-search>
        </div>
        <list-post :pagePost="pagePost" :postType="postType" :postDomain="postDomain" :TemplatePop="TemplatePop"></list-post>
        <list-paging :totalPageCount="totalPageCount" @firstUpdate="firstPage" @itemUpdate="itemPage" @prevUpdate="prevPage" @nextUpdate="nextPage" @lastUpdate="lastPage" :currentPage="currentPage"></list-paging>
    </div>
  </div>
</template>

<script>
import { computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'
import TopBanner from "../components/topbanner/topbanner.vue";
import ListSearch from "../components/filtersearch/filtersearch.vue";
import ListPost from "../components/post/post.vue";
import ListPaging from "../components/paging/paging.vue";
import AboutMenu from "../components/aboutmenu/aboutmenu.vue";

export default {
  name: 'Researcher',
  setup() {
      const siteData = reactive({
        title: `활동 - WithYou 위드유치료교육연구소`,
        description: 'WithYou 위드유치료교육연구소 활동을 소개합니다.',
        canonical: 'https://withyoulove.co.kr/About/Activity',
      })
      useHead({
          title: computed(() => siteData.title),
          meta: [
              {
                  name: `description`,
                  content: computed(() => siteData.description),
              },
          ],
          link: [
              {
                  rel: `canonical`,
                  content: computed(() => siteData.canonical),
              },
          ]
      })
  },
  components: {
    TopBanner,
    ListPost,
    ListPaging,
    AboutMenu,
    ListSearch
  },
  data() {
      return {
          // 상단 배너 컨텐츠
          depthTitle: '연구소 소개',
          imgUrl: '../../images/view/topbanner/topbanner-re.png',
          firstTitle: "연구소 소개",
          lastTitle: '활동',
          breadCate: 'About',

          // 서브메뉴
          isCurrent: '4',

          // 탭 필터 카테고리 설정
          activityCategories: ['전체', '강의', 'MOU', '아동양육시설', '외부 사업', '연구 및 기획'],
          selectedCategory: '전체', // 현재 선택된 카테고리

          // 리스트
          TemplatePop: false,
          postType: true,
          postDomain: '/About/Activity/',
          pagePost: [],
          moreView: true,

          // 리스트 세팅 정보
          apiUrl: 'https://withyoulove.co.kr:8000/api/blogList/',
          queryOptions: {
              per_page: 1,
              cat: 4
          },

          // 검색
          keyword: '',

          // 페이징
          totalPageCount: null,
          currentPage: 1
      };
  },
  mounted() {
      // 라우터 쿼리에 따른 초기 세팅
      if(this.$route.query.keyword){
          this.keyword = this.$route.query.keyword;
          this.selectedCategory = this.$route.query.keyword; // 파라미터가 있으면 해당 탭 활성화
          this.queryOptions.per_page = 1;
      }

      if(this.$route.query.page){
          this.page = this.$route.query.page;
          this.queryOptions.per_page = this.page;
      }

      // js/common.js 호출
      this.more('paging');
  },
  methods: {
    changeCategory(cat) {
    this.selectedCategory = cat;

    if (cat === '전체') {
        this.keyword = ''; 
    } else {
        this.keyword = cat; 
    }

    this.currentPage = 1;
    this.queryOptions.per_page = 1;
    this.index = 1;
    this.page = 1;

    this.$router.push({
        path: this.$route.path,
        query: { 
            ...this.$route.query,
            keyword: this.keyword, 
            page: 1                
        }
    }).catch(() => {}); 

    this.more('paging');
},
    getSearchData(data) {
        this.keyword = data;

        this.currentPage = 1;
        this.page = 1;
        this.index = 1;
        this.queryOptions.per_page = 1;

        this.$router.replace({
            path: this.$route.path,
            query: {
                ...this.$route.query,
                keyword: this.keyword,
                page: 1
            }
        }).catch(() => {});

        this.more('paging');
    },
    itemPage: function(index){
        this.index = index;
        this.getPaging(index);
    },
    firstPage: function(index){
        this.index = index;
        this.index = 1
        this.getPaging(index);
    },
    prevPage: function(index){
        this.index = index;
        this.index--
        this.getPaging(index);
    },
    nextPage: function(index){
        this.index = index;
        this.index++
        this.getPaging(index);
    },
    lastPage: function(index){
        this.index = index;
        this.index = this.totalPageCount
        this.getPaging(index);
    }
  }
}
</script>